module.exports = __webpack_public_path__ + "static/media/bkt.6b36dc29.png";